import { useQuery } from '@tanstack/react-query'
import { fetchLoginMethods } from './api'

export const loginMethodKeys = {
  all: ['login-methods'] as const,
}

/**
 * 연결 왕복을 다녀와 다시 읽는 자리라 들고 있지 않는다. 들고 있으면 방금 추가한 것이 목록에
 * 나타나지 않는다.
 */
export function useLoginMethods(enabled: boolean) {
  return useQuery({
    queryKey: loginMethodKeys.all,
    queryFn: ({ signal }) => fetchLoginMethods(signal),
    enabled,
    gcTime: 0,
  })
}
